import React, { Component } from "react";
import { Form, Table, Input, Button } from 'antd';

const FormItem = Form.Item;

export class ChurchGroupsFields extends Component {
  constructor(props) {
    super(props);
    this.state = { groups: [], selectedRows: [], value: '' };
  }

  get rowSelection() {
    return {
      onSelect: (_selectedRowKeys, _selected, selectedRows) => { this.selectRows(selectedRows) },
      onSelectAll: (_selected, selectedRows) => { this.selectRows(selectedRows) }
    };
  }

  get columns() {
    return(
      [{
        title: 'Groups',
        dataIndex: 'name',
        className: 'groups-page__groups-column'
      }]
    );
  }

  get addedGroups() {
    return this.state.groups.map((group) => ({ name: group.name }));
  }

  onAddClick = () => {
    const groups = this.state.groups;
    groups.push({ name: this.props.form.getFieldValue('church_group'), key: groups.length });
    this.setState({ groups: groups, value: '' });
    this.props.form.resetFields('church_group');
  };

  onDeleteClick = () => {
    const groups = this.state.groups;
    this.setState({
      selectedRowKeys: [],
      groups: groups.filter((item) => this.state.selectedRows.indexOf(item) < 0)
    });
  };

  onChange = (event) => {
    this.setState({ value: event.target.value });
  };

  selectRows(selectedRows) {
    this.setState({ selectedRows: selectedRows });
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const hasSelected = this.state.selectedRows.length > 0;
    const hasValue = this.state.value.length > 0;

    return (
      <div className="m-24">
        <Table rowSelection={this.rowSelection} className="church-form groups-page__table" columns={this.columns} dataSource={this.state.groups} pagination={false} />
        <FormItem>
          {getFieldDecorator('church_group', {
            rules: [
              { required: this.state.groups.length === 0, message: 'Please add at least 1 Group'}
            ],
          })(
            <Input onChange={this.onChange} placeholder="Group name" />
          )}
        </FormItem>
        <FormItem className="profile-form__item--hidden">
          {getFieldDecorator('church_groups', {
            initialValue: this.addedGroups
          })(
            <Input />
          )}
        </FormItem>
        <div className="groups-page__controls">
          <Button type="primary" className="church-form__control-item" disabled={!hasValue} onClick={this.onAddClick}>Add group</Button>
          <Button type="danger" disabled={!hasSelected} onClick={this.onDeleteClick} className="church-form__control-item profile-form__inactive-button">
            Delete selected
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/churches/form/churchGroupsFields.js